/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextStyle, Banner, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';

type Props = {
  tenantApp: Object
};

type ComposedProps = Props & WithI18nProps;

class BannerUpgrade extends Component<ComposedProps> {
  render() {
    const { i18n } = this.props;

    return (
      <Banner
        title={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_title')}
        status="info"
        action={{
          content: i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_action_upgrade'),
          onAction: this.props.handleUpgrade
        }}
        secondaryAction={{
          content: (
            <Link external url={`${URL['ThemeSetupV3Doc_learn_more']}`}>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_action_more')}
            </Link>
          )
        }}>
        <div>
          <p>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content1')}</p>
          <ul style={{ marginBlockStart: '2px', paddingInlineStart: '28px' }}>
            <li>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content2', {
                t: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content2_t')}
                  </TextStyle>
                )
              })}
            </li>
            <li>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content3', {
                t: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content3_t')}
                  </TextStyle>
                )
              })}
            </li>
            <li>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content4', {
                t: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content4_t')}
                  </TextStyle>
                )
              })}
            </li>
          </ul>
          <p>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content5')}</p>
          <p>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content6')}</p>
          <p>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content7')}</p>
          <p>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_content8')}</p>
        </div>
      </Banner>
    );
  }
}

const mapStateToProps = state => ({
  tenantApp: _.get(state.oauth, 'tenantApp', {})
});

export default connect(mapStateToProps)(withI18n()(BannerUpgrade));
